export default {
  authenticated: false,
  id: '',
  lastUserId: '',
  email: '',
  phone: '',
  phoneCountryCode: '',
  phoneVerified: false,
  phoneVerifyFinished: true,
  deletingPhoneInProgress: false,
  firstName: '',
  lastName: '',
  name: '',
  avatar: '',
  card: {
    brand: '',
    last4: '',
  },
  userSettingsLoading: false,
  settings: {
    message_notification: true,
    subscriber_notification: true,
  },
  userLoaded: false,
  successUpdate: false,
  successPasswordUpdate: false,
  successEmailUpdate: false,
  successPhoneUpdate: false,
  invitationAccepted: false,
  settingsUpdated: false,
  passwordResetSent: false,
  paymentCardChanged: false,
  oneSignalIdAdded: false,
  oneSignalIdRemoved: false,
  userSignedOut: false,
  available: true,
  invitations_accepted: [],
  checkingPassword: false,
  incognito: [],
  permissions: {},
  region: 'US',
  role: {},
  apiError: {},
  permissionDenied: {},
};
